import {
  shouldShowRevisionCheckBox,
  shouldShowValidationCheckBox,
  handleRevisionCheck,
  handleValidationCheck,
} from 'helpers/CheckBoxHelper';

import CheckBox from 'components/shared/CheckBox';
import CheckBoxRadio from 'components/shared/CheckBoxRadio';
export const ValidationAndRevisionCheckBoxGroup = ({
  userRole,
  availableValidationNumber,
  availableRevisionNumber,
  eligibleTextForValidation,
  isTextEligibleForValidation,
  orderType,
  revisionDisabled,
  selectedTextsForValidation,
  selectedTextsForRevision,
  sortedTexts,
  setSelectedTextsForRevision,
  setSelectedTextsForValidation,
}) => (
  <>
    {shouldShowValidationCheckBox(userRole, availableValidationNumber) && (
      <CheckBoxRadio
        checked={
          selectedTextsForValidation.length === eligibleTextForValidation.length
        }
        onCheck={(e) =>
          handleValidationCheck(
            e,
            sortedTexts,
            setSelectedTextsForValidation,
            isTextEligibleForValidation
          )
        }
        className={selectedTextsForValidation.length > 0 ? 'border-green' : ''}
      />
    )}
    {shouldShowRevisionCheckBox(
      orderType,
      userRole,
      availableRevisionNumber,
      revisionDisabled
    ) && (
      <CheckBox
        name="select-all"
        tick={selectedTextsForRevision.length > 1}
        onCheck={(e) =>
          handleRevisionCheck(e, sortedTexts, setSelectedTextsForRevision)
        }
      />
    )}
  </>
);
